export default "__VITE_ASSET__7da3fa18__"